import { useIntl } from '@/intl'
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints'
import { getTransportSelector } from '@/scopes/prices/components/selectors'
import { FlightSelectorDesktop } from '@/scopes/prices/components/TransportSelector/FlightSelector/FlightSelectorDesktop'
import { FlightSelectorMobile } from '@/scopes/prices/components/TransportSelector/FlightSelector/FlightSelectorMobile'
import { FlightTypeInfo } from '@/scopes/prices/components/TransportSelector/FlightSelector/FlightTypeInfo'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { UnavailableContentDialog } from '@sunwebgroup/ui-components'
import { Button } from '@sunwebgroup/ui-components/uds'

export function FlightSelector() {
  const intl = useIntl()
  const { isDesktopSm } = useBreakpoints()
  const { error } = usePricesSelector(getTransportSelector)

  if (error) {
    return (
      <UnavailableContentDialog
        title={intl.formatMessage({ id: 'prices_flight_selector_error_title' })}
        message={intl.formatMessage({ id: 'prices_flight_selector_error_message' })}
      >
        <Button onClick={() => window.location.reload()}>
          {intl.formatMessage({ id: 'prices_error_reload_button' })}
        </Button>
      </UnavailableContentDialog>
    )
  }

  return (
    <>
      {isDesktopSm ? <FlightSelectorDesktop /> : <FlightSelectorMobile />}
      <FlightTypeInfo />
    </>
  )
}
